const RECOVERY_KEY = 'beauti:chunk-reload-attempted';

export const isChunkLoadError = (error) =>
  error?.name === 'ChunkLoadError' ||
  /Loading (?:CSS )?chunk [\w-]+ failed|Failed to fetch dynamically imported module|Importing a module script failed/i.test(error?.message || '');

// Persist before navigating. A failing new build must never create a reload loop.
// If storage is blocked, leave the normal error screen available instead.
export const recoverChunkLoad = (error, options = {}) => {
  if (!isChunkLoadError(error)) return false;
  const notify = (action, marker = {}) => {
    try { options.onDecision?.({ action, reference: marker.reference || options.reference, fromRelease: marker.release }); } catch {}
  };
  try {
    const storage = options.storage || window.sessionStorage;
    const release = options.release || Array.from(document.scripts)
      .map(script => script.src.match(/main\.[a-f0-9]{8,64}\.js/)?.[0])
      .find(Boolean) || 'unknown';
    const now = options.now ?? Date.now();
    const raw = storage.getItem(RECOVERY_KEY);
    const previous = raw && raw !== '1' ? JSON.parse(raw) : null;
    // A tab can survive multiple deployments. Allow the new release to recover,
    // but never loop on one release or bounce rapidly between broken builds.
    if (previous && (previous.release === release || now - previous.at < 60000)) { notify('guarded', previous); return false; }
    if (raw === '1' && release === 'unknown') { notify('guarded'); return false; }
    const marker = {release, at: now};
    if (/^EB-[A-Z0-9]{6,16}-[A-Z0-9]{1,8}$/.test(options.reference || '')) marker.reference = options.reference;
    storage.setItem(RECOVERY_KEY, JSON.stringify(marker));
    notify('reload_requested', marker);
    (options.reload || (() => window.location.reload()))();
    return true;
  } catch {
    notify('recovery_unavailable');
    return false;
  }
};
